import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/service/http.service';
import { Empty } from '../../shared/error/empty';
import { FindHttpError } from '../../shared/error/find-http-error';
import { Observable } from 'rxjs/Observable';
import { HttpError } from '../../shared/error/http-error';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AppraisalTestService {
  private static APPRAISAL_TEST_END_POINT = '/appraisalTest';

  private CREATE_AS_MAP = `${AppraisalTestService.APPRAISAL_TEST_END_POINT}/createAsMap`;
  private FIND_AS_MAP = `${AppraisalTestService.APPRAISAL_TEST_END_POINT}/findAsMap`;

  find$: Observable<any>;
  error$: Observable<HttpError>;

  private findSubject: Subject<any>;
  private errorSubject: Subject<HttpError>;

  constructor(private _httpService: HttpService) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  createAsMap(equipmentType) {
    this.findAppraisalTestItems(this._httpService.post(this.CREATE_AS_MAP, equipmentType, Empty, FindHttpError));
  }

  findAsMap(appraisalId) {
    this.findAppraisalTestItems(this._httpService.get(`${this.FIND_AS_MAP}/${appraisalId}`, Empty, FindHttpError));
  }

  private findAppraisalTestItems(observable) {
    observable
      .subscribe(
        items => this.findSubject.next(items),
        error => this.errorSubject.next(error)
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/service/appraisal-test.service.ts